import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// ant-design
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.less";

// font
import "./assets/fonts/avenir/fonts.css";

// markdown
import "github-markdown-css/github-markdown.css";

Vue.config.productionTip = false;

Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
